(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["carousel"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function () {
    $('.slider_wrap').slick({
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    $('.slider_wrap').css('opacity', '1');
  });


  } catch(e) { console.error(e); }
})();

})();
